import * as React from "react";
import classNames from "classnames";

export interface ITitleProps {
    title: string;
    isTitleH1?: boolean;
    linkHref?: string;
    linkTarget?: string;
    className?: string;
}

const Title = ({ title, isTitleH1, className, linkHref, linkTarget }: ITitleProps) => {
    const baseClass = "title";
    const componentClasses = classNames(baseClass, className, "h2-style");
    const titleHtml = linkHref ? (
        <a className="reset-a" href={linkHref} target={linkTarget}>
            {title}
        </a>
    ) : (
        title
    );

    return isTitleH1 ? (
        <h1 className={componentClasses}>{titleHtml}</h1>
    ) : (
        <h2 className={componentClasses}>{titleHtml}</h2>
    );
};

export default Title;
